import styled from 'styled-components'
import React from "react";
import AddFilterIcon from './AddFilterIcon'

const AddFilterButtonDiv = styled.div`
  height: 20px;
  font-size: 12pt;
  font-weight: 500;
  display: inline-block;
  cursor: pointer;
  vertical-align: middle;
`

const IconButtonRowWrapper = styled.div`
  display: inline-block;
  padding: 0px 16px;
  vertical-align: middle;
`

const IconButtonWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
`

const AddFilterText = styled.div`
  padding: 0px 8px;
  cursor: pointer;
  display: inline-block;
  font-family: "Circular Std"
  line-height: 30px;
  color: #22A7FF;
  vertical-align: middle;
`

const AddFilterButton = ({ onClick }) => (
    <AddFilterButtonDiv onClick={onClick}>
      <IconButtonRowWrapper>
        <IconButtonWrapper>
          <AddFilterIcon />
        </IconButtonWrapper>
        <AddFilterText>Add Filter</AddFilterText>
      </IconButtonRowWrapper>
    </AddFilterButtonDiv>
)

export default AddFilterButton
